import { css } from '@/styled-system/css';

export const pageFooterContainer = css({
  marginTop: '3x',
});

// Desktop breakout: cancels detailMainContentPadding (4x) so the grey SEO
// panel and the dark Footer band bleed flush to the sidebar edges. Mobile
// keeps the parent 2x padding intact.
export const fullBleedDesktop = css({
  md: {
    marginLeft: '-4x',
    marginRight: '-4x',
  },
});

// Scoped override: bumps the shared SeoFooter article's inner side-padding
// from 16px to 32px on desktop so the text inset matches the rest of the
// HALO page's 4x content padding. !important is needed to defeat the
// styled-components class on DesktopSeoFooterArticle. Mobile SeoFooter uses
// SrpContentWrapper (not the article) and is unaffected.
export const seoFooterInnerPadding = css({
  md: {
    paddingLeft: '4x !important',
    paddingRight: '4x !important',
  },
});
